import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How ikigai has changed my style",
  "description": "",
  "published": "2010-01-12T00:00:00.000Z",
  "redirect_from": ["/blog/how-ikigai-has-changed-my-style/swizec/1082"],
  "categories": "food for thought, life, Pay it forward, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This is the second post in the series of `}<em parentName="p">{`How `}{`<`}{`x> changed my style`}</em>{` where I shall talk about tools and events that had a significant impact on my style of doing things. If you happen to like this idea, I would be very happy if you could help it spread like wildfire, because it's a form of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Pay_it_forward",
        "title": "Pay it forward"
      }}>{`pay-it-forward`}</a>{` where we say Thanks for cool stuff.`}</p>
    <p>{`A few weeks ago, or was it days, I forget, I stumbled upon a rather fascinating video about living to be a hundred years old and more. But not just sitting around and waiting to die kind of 100+, the kind where at 100 you're still happily running around, building fences and doing stupid crap most westerners really wouldn't expect you to do anymore.`}</p>
    <p>{`Everything in there is fine and good, but the most important bottom line I picked up on was the importance of having an `}<em parentName="p">{`ikigai`}</em>{`. It's all wonderfully explained in the video so I won't go into what ikigai is, I'd rather say a little bit about what it feels like to discover one's ikigai. (it doesn't matter whether you know what it's called or not, I didn't for months)`}</p>
    <p>{`As late as just last Spring my life revolved around going to a school I hated, having a job that was alright but not quite `}<em parentName="p">{`that`}</em>{` and occasionally getting together with my girlfriend. I was doing some nifty stuff in the evenings and late at night, but mostly it was just another burden no matter how much I loved it and felt like I believed in it.`}</p>
    <p>{`Then something changed, I can't exactly put my finger on it, but it changed. The symptom of this change was that I quit my job and devoted most of my attention to the side-project, which evolved far far far away from what it was back then.`}</p>
    <p>{`And suddenly much was different. School suddenly seemed interesting and awesome, I started learning exciting new things every day for the first time since being a kid. Getting up in the morning was ... well it's still fucking hard, I'm just not a morning person :P ... but staying up at night was painless as hell. Meh, I won't pretend like I can describe this, just try it.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/41e4a41d-a6dd-400e-aecf-26c5f4ec51c7/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=41e4a41d-a6dd-400e-aecf-26c5f4ec51c7",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      